export function appContentLink(path: string) {
  return `${window.location.origin}${window.location.pathname}#${path}`;
}

export async function copyAppLink(path: string) {
  const link = appContentLink(path);
  if (!navigator.clipboard?.writeText) throw new Error("Copy is unavailable in this browser. Copy the URL from the address bar instead.");
  await navigator.clipboard.writeText(link);
  return link;
}
